<div mat-dialog-draggable-title cdkDrag cdkDragRootElement=".cdk-overlay-pane" id="modal" cdkDragHandle>
	<!--cdkDragHandle-->
	<a class="float-right btnClose" (click)="cerrarPopup()"><i class="fal fa-times" style="cursor: pointer;"></i></a>
	<a class="float-right btnClose" (click)="maximizarPopup()"><i class="fal fa-window-maximize"></i></a>
	<a class="float-right btnClose" (click)="minimizarPopup()"><i class="fal fa-window-minimize"></i></a>
	<div style="margin:0 auto; text-align: center;">
		<div class="matTitulo">
			<i class="fal fa-file-search" id="ico"></i>
			<h1 class="titulo" style="display:inline-block;">Reporte Diario</h1>
		</div>
		<mat-divider></mat-divider>
	</div>
</div>
<mat-card class="mt-2">
	<mat-card-content class="card-content">
		<div class="row">
			<div class="col-lg-12 col-xl-12">
				<h4 *ngIf="vehiculoInfo">{{vehiculoInfo.descripcion}}</h4>
			</div>
			<div class="col-lg-12 col-xl-8">
				<span>Especifique una fecha en el cual desea obtener informacion del vehículo.</span>
			</div>
		</div>
		<mat-divider class="mt-3"></mat-divider>
		<dx-validation-group #targetGroup>
			<div class="row mt-3">
				<div class="col-lg-3 col-xl-3 mt-3">
					<dx-date-box [(value)]="fecha" type="date" displayFormat="dd-MM-yyyy">
					</dx-date-box>
				</div>
				<div class="col-lg-3 col-xl-3 mt-3">
					<dx-date-box [(value)]="horaInicial" type="time">
					</dx-date-box>
				</div>
				<div class="col-lg-3 col-xl-3 mt-3">
					<dx-date-box [(value)]="horaFinal" type="time">
					</dx-date-box>
				</div>
				<div class="col-lg-3 col-xl-3 mt-3">
					<button id="boton" type="submit" class="btn btn-success" (click)="buscarInformacion()"><i
							class="fal fa-search"></i>Buscar</button>&nbsp;
				</div>
			</div>
		</dx-validation-group>
		<mat-divider class="mt-3"></mat-divider>
		<div class="grid">
			<dx-data-grid *ngIf="showTable" id="gridContainer" [columnHidingEnabled]="true" [dataSource]="reportePos"
				[showBorders]="true">
				<dxo-filter-row [visible]="showFilterRow"></dxo-filter-row>
				<dxo-paging [pageSize]="5"></dxo-paging>
				<dxo-pager [showPageSizeSelector]="true" [allowedPageSizes]="[5, 10, 25, 50, 100]">
				</dxo-pager>
				<dxi-column caption="Acciones" cellTemplate="Abrir" alignment="center" [width]="100">
				</dxi-column>
				<dxi-column dataField="fecha" alignment="center" dataType="date" format="shortDateShortTime"
					[width]="200">
					<dxo-header-filter [dataSource]="orderHeaderFilter"></dxo-header-filter>
				</dxi-column>
				<dxi-column dataField="placas" alignment="center" caption="Placa"></dxi-column>
				<dxi-column dataField="ignicion" alignment="center" caption="Ignición"></dxi-column>
				<dxi-column dataField="edo" alignment="center" caption="Estado"></dxi-column>
				<dxi-column dataField="velocidad" alignment="center" caption="Velocidad Km/h"></dxi-column>
				<dxi-column dataField="lat" alignment="center" caption="Latitud" [hidingPriority]="1">
				</dxi-column>
				<dxi-column dataField="lng" alignment="center" caption="Longitud" [hidingPriority]="1">
				</dxi-column>
				<div *dxTemplate="let d of 'Abrir'" (click)="ubicarPuntoHistorico(d.data)" style="text-align: center;">
					<dx-button style="background-color: #fff;" class="btnAcciones">
						<i class="fa fa-eye" style="color:#166BA2"></i>
					</dx-button>
				</div>
			</dx-data-grid>
		</div>

	</mat-card-content>
</mat-card>

<dx-load-panel #loadPanel shadingColor="rgba(0,0,0,0.4)" [(visible)]="loadingVisible" [showIndicator]="true"
	[showPane]="true" [shading]="true" [closeOnOutsideClick]="false">
</dx-load-panel>
